<div class="eventq-camera-grid" role="list" [attr.aria-label]="'Camera grid ' + layout()">
  <!-- Track by camera so removing one moves the surviving tiles instead of rebinding them. -->
  @for (cameraId of slots(); track cameraId ?? 'empty-slot-' + $index) {
    <div class="eventq-camera-grid__cell" role="listitem">
      @if (cameraId; as id) {
        @if (cellTemplate(); as tpl) {
          <ng-container
            [ngTemplateOutlet]="tpl"
            [ngTemplateOutletContext]="{ $implicit: id, index: $index }"
          />
        }
      } @else {
        <div class="eventq-camera-grid__empty">
          <img
            class="eventq-camera-grid__empty-icon"
            [src]="emptyIconSrc() | prefixUrl"
            width="32"
            height="32"
            alt=""
          />
          <p class="eventq-camera-grid__empty-label">{{ emptyLabel() }}</p>
        </div>
      }
    </div>
  }
</div>
